import React, { useContext } from "react";
import { LegacyCard as Card, Collapsible, Text, Layout, TextField } from "@shopify/polaris";

// import hoc
import { withErrorBoundary, withFeature } from "lib/hoc";

// import constant
import constant from "lib/constant/constant";
import { baseHelper } from "lib/helpers";

// import context
import { PrivateContext } from "lib/context";
import { BrandingContext } from "app/setup/modules/operator/features/branding/context/context";

const FinishDescription = () => {
  const { CHARACTER_COUNT, DEFAULT_FINISH_DESCRIPTION } = constant;
  const { setOnboarding, onboarding, setIsSubmitEnable, finishDescription } = useContext(BrandingContext);
  const { cms = () => {}, currentUser } = useContext(PrivateContext);
  const { brand } = currentUser || {};
  const { finish, updatedAt: brandUpdatedAt = "" } = brand || {};
  const { description: finishDesc } = finish || {};
  const { updatedAt = "" } = finishDesc || {};

  const onChangeAction = (value) => {
    if (value && value.slice(0, CHARACTER_COUNT)) {
      setOnboarding({ ...onboarding, finishDescription: value.slice(0, CHARACTER_COUNT) });
      setIsSubmitEnable(true);
    }
    if (!value) {
      setOnboarding({ ...onboarding, finishDescription: "" });
      setIsSubmitEnable(true);
    }
  };

  return (
    <Collapsible open>
      <Layout.AnnotatedSection
        title={cms("section.finishDescription.title")}
        description={cms("section.finishDescription.description")}
      >
        <Card
          title={[
            cms("section.finishDescription.card.title"),
            updatedAt ? (
              <Text as="span" tone="subdued">
                <Text variant="bodySm" as="p">{`${baseHelper.lastUpdateDate(updatedAt)}`}</Text>
              </Text>
            ) : (
              <Text as="span" tone="subdued">
                <Text variant="bodySm" as="p">{`${baseHelper.lastUpdateDate(brandUpdatedAt)}`}</Text>
              </Text>
            ),
          ]}
          actions={
            finishDescription !== DEFAULT_FINISH_DESCRIPTION && [
              {
                content: cms("label.reset"),
                onAction: () => [
                  setOnboarding({ ...onboarding, finishDescription: DEFAULT_FINISH_DESCRIPTION }),
                  setIsSubmitEnable(true),
                ],
              },
            ]
          }
        >
          <Card.Section>
            <div className="h100-textfield">
              <TextField value={finishDescription} onChange={(value) => onChangeAction(value)} multiline={4} />
            </div>
            <br />
            <Text as="span" tone="subdued">
              {`${CHARACTER_COUNT - finishDescription.length} / ${CHARACTER_COUNT}`}
            </Text>
          </Card.Section>
        </Card>
      </Layout.AnnotatedSection>
    </Collapsible>
  );
};

export default withFeature(withErrorBoundary(FinishDescription), {
  feature: constant.STANDARD_BRANDING,
});
